import { Stack, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { getAllExpense } from "../../api";
import { useSnackbar } from "notistack";
import LoadingContent from "../common/LoadingContent";
import ExpenseCard from "../cards/ExpenseCard";

export const Expense = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchExpenses = () => {
    setLoading(true);
    getAllExpense({
      filter: {
        status: ["PENDING", "ACTIVE"],
      },
    })
      .then((res) => setExpenses(res.data.rows))
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchExpenses();
  }, []);

  return (
    <>
      <LoadingContent loading={loading}>
        <Stack>
          {expenses.length > 0 ? (
            expenses.map((expense) => (
              <ExpenseCard
                key={expense.id}
                data={expense}
                enqueueSnackbar={enqueueSnackbar}
                approve
                reset={fetchExpenses}
              />
            ))
          ) : (
            <Typography sx={{ textAlign: "center", py: 5 }}>
              No expense found!
            </Typography>
          )}
        </Stack>
      </LoadingContent>
    </>
  );
};

export default Expense;
